import React from 'react';
import { List, Card, Header, Button } from 'semantic-ui-react';
import { instrumentationCursorCap } from '../../util/InstStrings';

export const InstrumentationCard = (insts, instMap, cursor = -1) => {

    //console.log("instrumentation card", insts, instMap);

    const debugFn = () => {
        console.log("debug", insts);
    };

    //const debugBtn = (<Button onClick={debugFn}>Debug</Button>);
    const debugBtn = <></>;

    const cssSelec = 'instrumentation-card instrumentation-card-selected';
    const cssUnselec = 'instrumentation-card';

    const newItem = (
        <List.Item key='newitem'>
            <Card className={cssSelec}>
                {debugBtn}
                (New Entry)
            </Card>
        </List.Item>
    );
    
    if (!insts || !insts.type) {
        if (cursor === 0) {
            return newItem;
        } else {
            return (
                <List.Item>{debugBtn}Invalid data</List.Item>
            );
        }
    }

    if (insts.type === "inst") {
        const cssClass = cursor === 0 ? cssSelec : cssUnselec;
        return (
            <List.Item>
                <Card className={cssClass}>
                    {instMap[insts.id].name}
                </Card>
            </List.Item>
        ); 
    }

    if (insts.type === "set") {
        const text = insts.operator === "AND" ? "ALL OF" :
                     insts.operator === "OR" ? "ONE OF" :
                     insts.operator === "THEN" ? "SEQUENTIALLY" : "";

        const conjunction = (k) => (
            <List.Item key={`$conj-${k}`}>
                <Header as='h6' color='green' className='subtitle'>
                    -- {insts.operator} --
                </Header>
            </List.Item>);
                    
        let cursorCounter = 2;
        const subcards = insts.items.flatMap((item, i) => {
            const card = InstrumentationCard(item, instMap, cursor-cursorCounter);
            cursorCounter += instrumentationCursorCap(item);
            const result = [(
                <List.Item key={i}>
                    {card}
                </List.Item>
            )];
            
            if (cursor - cursorCounter === 0) {
                result.push(conjunction(`newitem-${i}`));
                result.push(newItem);
            }

            if (i < insts.items.length - 1) {
                result.push(conjunction(i))
            }
            cursorCounter++;
            return result;
            
        });
        if (cursor === 1) {
            subcards.splice(0,0,newItem);
            if (insts.items.length > 0) {
                subcards.splice(1,0,conjunction("newitem-initial"));
            }
        }

        const cssClass = cursor === 0 ? cssSelec : cssUnselec;
        return (
            <List.Item>
                <Card className={cssClass}>
                    <Card.Header className='instrumentation-card-header'>
                        <Header as='h4' color='green' className='subtitle'>{text}{debugBtn}</Header>
                    </Card.Header>
                    <List.List>
                        {subcards}
                    </List.List>
                </Card>
            </List.Item>
        )
    }
}